import { c as _c } from "react/compiler-runtime";
import { useFilterQueryParams } from "@hooks/table-filters/use-filter-query-params";
import { FilterChipNumber } from "@components/common/faro-table/faro-table-filter/filter-chip-number";
import { Chip } from "@flat-ui";
/** A chip for filtering table's data */
export function FilterChip(t0) {
  const $ = _c(15);
  const {
    filteredColumn,
    label,
    onClick,
    shouldHaveDropdown,
    isDropdownOpen: t1
  } = t0;
  const isDropdownOpen = t1 === undefined ? false : t1;
  const {
    getFilterIdsForColumn
  } = useFilterQueryParams();
  let t2;
  if ($[0] !== filteredColumn || $[1] !== getFilterIdsForColumn) {
    t2 = getFilterIdsForColumn(filteredColumn);
    $[0] = filteredColumn;
    $[1] = getFilterIdsForColumn;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const activeFilterIds = t2;
  const numberOfActiveFilters = activeFilterIds.length;
  const isActive = numberOfActiveFilters > 0;
  const t3 = !shouldHaveDropdown && isActive ? onClick : undefined;
  const t4 = isDropdownOpen || isActive ? "primary" : "default";
  const t5 = shouldHaveDropdown ? "row-reverse" : "row";
  let t6;
  if ($[3] !== t5) {
    t6 = {
      flexDirection: t5,
      mt: "5px"
    };
    $[3] = t5;
    $[4] = t6;
  } else {
    t6 = $[4];
  }
  let t7;
  if ($[5] !== numberOfActiveFilters || $[6] !== shouldHaveDropdown) {
    t7 = <FilterChipNumber shouldHaveDropdown={shouldHaveDropdown} numberOfActiveFilters={numberOfActiveFilters} />;
    $[5] = numberOfActiveFilters;
    $[6] = shouldHaveDropdown;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  let t8;
  if ($[8] !== label || $[9] !== onClick || $[10] !== t3 || $[11] !== t4 || $[12] !== t6 || $[13] !== t7) {
    t8 = <Chip onClick={onClick} onDelete={t3} label={label} variant="outlined" color={t4} size="small" sx={t6} icon={t7} />;
    $[8] = label;
    $[9] = onClick;
    $[10] = t3;
    $[11] = t4;
    $[12] = t6;
    $[13] = t7;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  return t8;
}